module.exports = __webpack_public_path__ + "assets/5.631d6198.svg";